import * as React from 'react';
import { TInfoBlocks } from './InfoBlocks.types';
import { infoBlocksData } from './InfoBlocks.constants';
import './InfoBlocks.styled.scss';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';

export const InfoBlocks: TInfoBlocks = () => {
  const localize = useLocalize();

  return (
    <div className="info-blocks">
      {infoBlocksData.map((block) => (
        <div key={block.id} className="info-blocks__item">
          <div className="info-blocks__item__icon">{block.icon}</div>
          <h3 className="info-blocks__item__title">
            {localize(`home.infoblocks.${block.slug}.title`)}
          </h3>
          <p className="info-blocks__item__description">
            {localize(`home.infoblocks.${block.slug}.description`)}
          </p>
        </div>
      ))}
    </div>
  );
};
